import React, { useRef, useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import '../styles/notify.css';
import '../styles/sections.css';
import '../styles/utilities.css';

import {
  Overview,
  AppShowcase,
  Requirements,
  Technologies,
  Diagrams,
  Challenges
} from './NotifyComponents';


const Notify = () => {
  const refs = {
    overview: useRef(null),
    showcase: useRef(null),
    requirements: useRef(null),
    technologies: useRef(null),
    diagrams: useRef(null),
    challenges: useRef(null),
  };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-sans bg-white text-gray-800 min-h-screen flex flex-col">
      <Navbar refs={refs} />

      <main className="flex-grow">
        <section className="notify-title-section">
          <div className="notify-title">
            <h1 className="notify-title-text">NOTIFY SHOWCASE</h1>
          </div>
        </section>
        
        <section ref={refs.overview}>
          <Overview />
        </section>
        
        <section ref={refs.showcase}>
          <AppShowcase />
        </section>
        
        <section ref={refs.requirements}>
          <Requirements />
        </section>
        
        <section ref={refs.technologies}>
          <Technologies />
        </section>
        
        <section ref={refs.diagrams}>
          <Diagrams />
        </section>
        
        <section ref={refs.challenges}>
          <Challenges />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Notify;
